import { render, staticRenderFns } from "./NavigationCard.vue?vue&type=template&id=67a8f75e&"
import script from "./NavigationCard.ts?vue&type=script&lang=ts&"
export * from "./NavigationCard.ts?vue&type=script&lang=ts&"
import style0 from "./NavigationCard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports